import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import avatar from '../../../../assets/images/about/ceo/avatar.png';
import './Ceo.css';

const Ceo = () => {
  return (
    <section className="ceo">
      <div className="ceo__inner">
        <Reveal as="blockquote" className="ceo__quote">
          “We believe successful investing requires clarity, discipline, and
          trust. At VBS, we deliver strategic insight and tailored solutions
          designed to navigate complexity and create long-term value for our
          clients.”
        </Reveal>

        <Reveal className="ceo__person" delay={80}>
          <img
            className="ceo__avatar"
            src={avatar}
            alt="Gezim Vuca, CEO"
          />
          <p className="ceo__name">Gezim Vuca</p>
          <p className="ceo__role">CEO</p>
        </Reveal>
      </div>
    </section>
  );
};

export default Ceo;
